import { PageHero, SHELL, Reveal, Mono, StatusBadge } from "@/components/bits";
import { ROADMAP } from "@/lib/data";

export default function Roadmap() {
    return (
        <div data-testid="roadmap-page">
            <PageHero
                label="PROTOCOL ROADMAP"
                title={"FOUR PHASES.\nNO DATES. ONLY STATES."}
                sub="VERA develops from foundation to a global capital network. Phases carry explicit states instead of invented deadlines."
            />
            <section className="py-20 md:py-28">
                <SHELL>
                    <div className="relative">
                        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gradient-to-b from-vera-blue/50 via-vera-blue/20 to-vera-gold/50" aria-hidden="true" />
                        <div className="space-y-6">
                            {ROADMAP.map((ph, i) => (
                                <Reveal key={ph.num} delay={i * 0.05}>
                                    <div className="relative pl-10" data-testid={`roadmap-phase-${ph.num}`}>
                                        <div className={`absolute left-0 top-8 w-3.5 h-3.5 rotate-45 border ${ph.status === "BUILDING" ? "border-vera-gold bg-vera-gold/30" : "border-vera-blue bg-vera-bg"}`} aria-hidden="true" />
                                        <div className="glass-card p-8 hover:border-vera-blue/40 transition-colors">
                                            <div className="flex flex-wrap items-center justify-between gap-4 mb-7">
                                                <div className="flex items-center gap-5">
                                                    <span className="font-mono text-2xl font-bold text-white/15">{ph.num}</span>
                                                    <h3 className="font-mono text-sm tracking-[0.3em] text-vera-white">{ph.title}</h3>
                                                </div>
                                                <StatusBadge status={ph.status} />
                                            </div>
                                            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
                                                {ph.items.map((it) => (
                                                    <li key={it} className="flex items-start gap-3 text-sm text-vera-mut">
                                                        <span className="w-1 h-1 rotate-45 bg-vera-soft mt-2 shrink-0" aria-hidden="true" />
                                                        {it}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                    <Reveal>
                        <p className="font-mono text-[9px] tracking-[0.2em] text-vera-mut/60 mt-12">
                            PHASES ARE DESCRIPTIVE, NOT COMMITMENTS OR INVESTMENT MILESTONES — DATES WILL NEVER BE INVENTED
                        </p>
                    </Reveal>
                </SHELL>
            </section>
        </div>
    );
}
